import { RiTableLine } from '@remixicon/react';

import {
  CREATE_TABLE_BLOCK_TOOL,
  createToolExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const CreateTableBlockToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-table-block',
    predicate: tool => tool.endsWith(CREATE_TABLE_BLOCK_TOOL),
    icon: RiTableLine,
    display: 'grouped',
    render: () => null,
    renderTool: () => null,
  }),
);
